export default __webpack_public_path__ + "assets/json/grid-data6af8d5cfade575801b9da4876aa76b62.json";